import * as React from "react";
const SvgBadgeFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm8 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7-1a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2zm1 4a1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1m-6 4a4 4 0 0 0-8 0z", clipRule: "evenodd" }));
export default SvgBadgeFill;
